import { render } from "./card-oferte.vue?vue&type=template&id=ebf434c4&scoped=true&ts=true"
import script from "./card-oferte.vue?vue&type=script&lang=ts"
export * from "./card-oferte.vue?vue&type=script&lang=ts"

import "./card-oferte.vue?vue&type=style&index=0&id=ebf434c4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebf434c4"]])

export default __exports__